import { ActionTypes } from './Dirty.action-types';

export const setDirtyState = (data: boolean): ISetDirtyStateAction => ({
    type: ActionTypes.SET_DIRTY_STATE,
    data
});

export interface ISetDirtyStateAction {
    type: ActionTypes.SET_DIRTY_STATE;
    data: boolean;
}
